import React, { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { Drawer, Box, Typography, Divider, Button, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Language } from '../../translations';
import { globalBuilder } from '../../archbuilder/GlobalBuilder';

interface DoubleDrawerProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const DoubleDrawer: React.FC<DoubleDrawerProps> = ({ open, setOpen }) => {
  const { t } = useContext(LanguageContext);
  return globalBuilder.Drawer(open, setOpen);
};

export default DoubleDrawer;
